const formatCents = (cents) => {
  const dollars = cents / 100;
  // Check if the value is a float
  if (!Number.isInteger(dollars / 1000)) {
    return dollars.toLocaleString();
  }

  return `${(dollars / 1000).toLocaleString()}k`;
};

const formatCompensationAmountRange = (amountMinCents, amountMaxCents) => {
  const hasMin = Boolean(amountMinCents);
  const hasMax = Boolean(amountMaxCents);
  if (hasMin && hasMax) {
    return `${formatCents(amountMinCents)}-${formatCents(amountMaxCents)}`;
  }
  if (hasMin) {
    return `${formatCents(amountMinCents)}+`;
  }
  if (hasMax) {
    return `up to ${formatCents(amountMaxCents)}`;
  }
  return '';
};

const getConvertedSuffix = ({
  convertedAmountMinCents,
  convertedAmountMaxCents,
  convertedCurrency,
  currency,
  period,
}) => {
  if (!convertedCurrency || currency === convertedCurrency) return '';
  const range = formatCompensationAmountRange(convertedAmountMinCents, convertedAmountMaxCents);
  if (!range) return '';
  return ` (${convertedCurrency} ${range} / ${period.toLowerCase()})`;
};

export const displayCompensationPeriod = (compensation = {}) => {
  const {
    amountMinCents,
    amountMaxCents,
    currency,
    period,
    offersEquity,
    convertedAmountMinCents,
    convertedAmountMaxCents,
    convertedCurrency,
  } = compensation;
  const amountRange = formatCompensationAmountRange(amountMinCents, amountMaxCents);
  if (!amountRange || !currency || !period) {
    return '';
  }
  const converted = getConvertedSuffix({
    convertedAmountMinCents,
    convertedAmountMaxCents,
    convertedCurrency,
    currency,
    period,
  });

  return `${currency} ${amountRange} / ${period.toLowerCase()}${converted}${offersEquity ? ' + Equity' : ''}`;
};
